<template>
  <LayoutActionCard
    :title="title"
    :subtitle="subtitle"
    :is-configured="isConfigured"
    :is-configure-active="isConfigureActive"
    :selected="selected"
    @delete="$emit('delete')"
    @configure="handleConfigure"
  >
    <template #icon>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="#FFFFFF"/>
      </svg>
    </template>

    <template #content>
      <!-- Not Configured State -->
      <div v-if="!isConfigured" class="action-content">
        <!-- Warning Message -->
        <!-- <div class="warning-message">
          <img src="@/assets/MyWorkBench/Workflow/warning_icon_triangel.svg" style="width: 20px; height: 20px; margin-right: 4px;" />
          <span class="warning-text">Required fields cannot be empty.</span>
        </div> -->

        <!-- Message Type Field -->
        <!-- <div class="form-field">
          <label class="field-label">
            Message Type <span class="required-mark">(Required)</span>
          </label>
          <WorkflowDropdown
            v-model="localFormData.messageType"
            placeholder="Select type ..."
            :options="messageTypeOptions"
            label-field-name="label"
            value-field-name="value"
            @update:model-value="updateSharedData"
          />
        </div> -->

        <!-- Subject Field -->
        <!-- <div class="form-field">
          <label class="field-label">Subject</label>
          <div class="input-container">
            <input
              v-model="localFormData.subject"
              type="text"
              class="text-input"
              placeholder="Email subject"
              @input="updateSharedData"
            />
            <button
              v-if="localFormData.subject"
              class="clear-btn"
              type="button"
              @click="clearSubject"
            >
              Clear
            </button>
          </div>
        </div> -->

        <!-- Message Content Field -->
        <!-- <div class="form-field">
          <label class="field-label">
            Message Content <span class="required-mark">(Required)</span>
          </label>
          <TextareaWithClear
            v-model="localFormData.messageContent"
            placeholder="Message content"
            :max-length="1000"
            :rows="5"
            @update:modelValue="updateSharedData"
          />
        </div> -->
              </div>

      <!-- Configured State -->
      <div v-else class="action-content action-content--configured">
        <div class="config-row">
          <span class="config-label">Message Type:</span>
          <span class="config-value">{{ displayMessageType }}</span>
        </div>
        <div class="config-row">
          <span class="config-label">Subject:</span>
          <span class="config-value">{{ displaySubject }}</span>
        </div>
        <div class="config-row config-row--vertical">
          <span class="config-label">Message Content:</span>
          <span class="config-value config-value--multiline">{{ displayMessageContent }}</span>
        </div>
              </div>
    </template>
  </LayoutActionCard>
</template>

<script>
import LayoutActionCard from './LayoutActionCard.vue';
import TextareaWithClear from '@/components/workflow/TextareaWithClear.vue';
import WorkflowDropdown from '@/components/workflow/WorkflowDropdown.vue';

export default {
  name: 'SendNotification',
  components: {
    LayoutActionCard,
    TextareaWithClear,
    WorkflowDropdown
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete', 'configure'],
  data() {
    return {
      localFormData: {
        messageType: this.data.messageType || 'in_app',
        subject: this.data.subject || '',
        messageContent: this.data.messageContent || ''
      },
      messageTypeOptions: [
        { label: 'Email', value: 'email' },
        { label: 'SMS', value: 'sms' },
        { label: 'In-App Message', value: 'in_app' }
      ]
    };
  },
  computed: {
    title() {
      return 'Send Notification';
    },
    subtitle() {
      return 'Send communication to patients';
    },
    displayData() {
      return (this.data && this.data.savedData) ? this.data.savedData : this.data;
    },
    isConfigured() {
      return Boolean(this.displayData && this.displayData.configured);
    },
    isConfigureActive() {
      // Configure is active when all required fields have content
      return Boolean(
        this.localFormData.messageType && this.localFormData.messageType.trim().length > 0 &&
        this.localFormData.subject && this.localFormData.subject.trim().length > 0 &&
        this.localFormData.messageContent && 
        this.localFormData.messageContent.trim().length > 0
      );
    },
    displayMessageType() {
      if (this.displayData && this.displayData.messageType) {
        const typeMap = {
          email: 'Email',
          sms: 'SMS',
          in_app: 'In-App Message'
        };
        return typeMap[this.displayData.messageType] || this.displayData.messageType;
      }
      return 'N/A';
    },
    displaySubject() {
      if (this.displayData && this.displayData.subject) {
        return this.displayData.subject;
      }
      return 'N/A';
    },
    displayMessageContent() {
      if (this.displayData && this.displayData.messageContent) {
        return this.displayData.messageContent;
      }
      return 'N/A';
    }
  },
  watch: {
    'data.messageType': {
      handler(newVal) {
        if (newVal !== this.localFormData.messageType) {
          this.localFormData.messageType = newVal || '';
        }
      },
      immediate: true
    },
    'data.subject': {
      handler(newVal) {
        if (newVal !== this.localFormData.subject) {
          this.localFormData.subject = newVal || '';
        }
      },
      immediate: true
    },
    'data.messageContent': {
      handler(newVal) {
        if (newVal !== this.localFormData.messageContent) {
          this.localFormData.messageContent = newVal || '';
        }
      },
      immediate: true
    }
  },
  methods: {
    handleConfigure() {
      this.$emit('configure', {
        messageType: this.localFormData.messageType,
        subject: this.localFormData.subject,
        messageContent: this.localFormData.messageContent
      });
    },
    updateSharedData() {
      // Update the shared data instance directly
      this.data.messageType = this.localFormData.messageType;
      this.data.subject = this.localFormData.subject;
      this.data.messageContent = this.localFormData.messageContent;
    },
    clearSubject() {
      this.localFormData.subject = '';
      this.data.subject = '';
    }
  }
};
</script>

<style scoped>
.action-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.action-content--configured {
  gap: 8px;
}

.warning-message {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  margin-bottom: 4px;
}

.warning-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.warning-text {
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333333;
  flex: 1;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: #4A4A4A;
}

.required-mark {
  color: #D10000;
  font-weight: 400;
}

.message-type-select {
  width: 100%;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
  padding: 8px 12px;
  transition: border-color 0.2s ease;
}

.input-container:focus-within {
  border-color: #004879;
}

.text-input {
  flex: 1;
  border: none;
  outline: none;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #333333;
}

.text-input::placeholder {
  color: #999999;
}

.textarea-container {
  background: #FFFFFF;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: border-color 0.2s ease;
}

.textarea-container:focus-within {
  border-color: #004879;
}

.action-textarea {
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #333333;
  min-height: 72px;
}

.action-textarea:focus {
  outline: none;
}

.action-textarea::placeholder {
  color: #999999;
}

.textarea-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.character-count {
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #999999;
}

.clear-btn {
  background: transparent;
  border: none;
  padding: 4px 10px;
  cursor: pointer;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #1E4670;
  text-decoration: underline;
  transition: opacity 0.2s ease;
}

.clear-btn:hover {
  opacity: 0.8;
}

.config-row {
  display: flex;
  gap: 4px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  line-height: 20px;
}

.config-row--vertical {
  flex-direction: column;
  gap: 4px;
}

.config-label {
  font-weight: 600;
  color: #374957;
}

.config-value {
  font-weight: 400;
  color: #333333;
}

.config-value--multiline {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-break: break-word;
}

:deep(.el-select .el-input .el-input__wrapper) {
  border-radius: 6px;
  border: 1px solid #d0d0d0;
  min-height: 40px;
  box-shadow: none;
}

:deep(.el-select .el-input .el-input__wrapper:hover) {
  border-color: #004879;
}

:deep(.el-select .el-input .el-input__wrapper.is-focus) {
  border-color: #004879;
  box-shadow: 0 0 0 2px rgba(0, 72, 121, 0.2);
}

:deep(.el-select .el-input__inner) {
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-size: 14px;
  color: #4a4a4a;
}

</style>
